import { TableFacetContextState } from 'modules/experiments/types';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { ALL_EXPERIMENT_STATUSES } from '../constants';

export const initialTableFacetContextState: TableFacetContextState = {
  /** Free form search */
  search: '',
  setSearch: noop,

  /** Experiments status tabs */
  selectedTab: ALL_EXPERIMENT_STATUSES,
  setSelectedTab: noop,

  /** Experiment and Campaign Filters */
  selectedFilters: [],
  clearSelectedFilters: noop,
};

export const TableFacetContext = createContext(initialTableFacetContextState);

export const useTableFacetContext = () => useContext(TableFacetContext);
